import { Amplify } from "aws-amplify"

let configured = false

export interface AmplifyConfigOptions {
  /** Cognito domain (e.g., "app.auth.us-east-2.amazoncognito.com") */
  domain?: string
  /** Cognito User Pool ID */
  userPoolId?: string
  /** Cognito User Pool Client ID */
  userPoolClientId?: string
  /** AWS Region */
  region?: string
  /** OAuth redirect URI for sign in */
  redirectSignIn?: string
  /** OAuth redirect URI for sign out */
  redirectSignOut?: string
  /** OAuth scopes */
  scopes?: string[]
}

/**
 * Configure AWS Amplify with Cognito settings
 * All options must be provided by the calling application
 */
export const configureAmplify = (options: AmplifyConfigOptions) => {
  if (configured) return

  const {
    domain,
    userPoolId,
    userPoolClientId,
    redirectSignIn,
    redirectSignOut,
    scopes = ["openid", "email", "profile", "aws.cognito.signin.user.admin"],
  } = options

  if (!domain || !userPoolId || !userPoolClientId) {
    console.error(
      "Cognito configuration missing: domain, user pool id, and client id are required"
    )
    return
  }

  if (!redirectSignIn || !redirectSignOut) {
    console.error(
      "Cognito configuration missing: redirectSignIn and redirectSignOut are required"
    )
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes,
            redirectSignIn: [redirectSignIn],
            redirectSignOut: [redirectSignOut],
            responseType: "code",
          },
        },
      },
    },
  })

  configured = true
}

/**
 * Reset configuration state (useful for testing)
 */
export const resetAmplifyConfig = () => {
  configured = false
}

/**
 * Check if Amplify has been configured
 */
export const isAmplifyConfigured = () => {
  return configured
}
